import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelect'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'
import moment from 'moment'
import { isInclusivelyBeforeDay } from 'react-dates'
import DatePicker from 'component/utils/DatePicker'
import Input from 'component/utils/Input'

const fields = ['listRegionsAndBranchs', 'dtStart', 'dtEnd', 'timeFilter']

class ReportsFilter extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    centerFilter: PropTypes.bool,
    preLoadedValues: PropTypes.object,
  }

  beforeOnSubmit = (event) => {
    const { onSubmit, values } = this.props
    event.preventDefault()

    onSubmit(values)
  }

  handleBranchMultiSelectChange = (value, input) => {
    input.value = value

    const event = {
      target: input,
    }

    input.onChange(event)
  }

  handleChangeDtStart = (event) => {
    const { setValueToField, fields } = this.props
    const { value } = event.target

    setValueToField(fields.dtStart.input.name, value)

    if (!value) {
      setValueToField(fields.dtEnd.input.name, null)
    }
  }

  handleChangeCheckBox = (event) => {
    const { fields } = this.props
    fields.timeFilter.input.onChange(event)
  }

  componentDidMount = () => {
    const { setValueToField, fields, preLoadedValues } = this.props

    if (preLoadedValues) {
      setValueToField(fields.dtStart.input.name, preLoadedValues.dtStart)
      setValueToField(fields.dtEnd.input.name, preLoadedValues.dtEnd)
      setValueToField(fields.timeFilter.input.name, preLoadedValues.timeFilter)
      if (preLoadedValues.listRegionsAndBranchs) {
        setValueToField(
          fields.listRegionsAndBranchs.input.name,
          preLoadedValues.listRegionsAndBranchs
        )
      }
    }
  }

  render() {
    const { fields, translate, values, centerFilter } = this.props

    return (
      <form onSubmit={this.beforeOnSubmit}>
        <Row>
          <Col xs={12}>
            <Field
              {...fields.listRegionsAndBranchs}
              hint={translate('totem.reports.store.hint')}
            >
              <RegionBranchMultipleSelect
                id='listRegionsAndBranchs'
                {...fields.listRegionsAndBranchs.input}
                placeholder=''
                components={{ MenuList, MultiValueContainer }}
                className='react-select-collapsible'
                translate={translate}
                onChange={(event) =>
                  this.handleBranchMultiSelectChange(
                    event.target.value,
                    fields.listRegionsAndBranchs.input
                  )
                }
                allOption
              />
            </Field>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Field
              {...fields.dtStart}
              className='margin-bottom-small'
              glyph='glyph glyph-calendar'
            >
              <DatePicker
                {...fields.dtStart.input}
                id={fields.dtStart.input.name}
                isOutsideRange={(date) =>
                  moment(date).isAfter(values.dtEnd) ||
                  !isInclusivelyBeforeDay(date, moment())
                }
                onChange={this.handleChangeDtStart}
                placeholder={translate('field.from')}
                scrollIntoView={false}
                showClearDate
              />
            </Field>
          </Col>
          <Col xs={6}>
            <Field
              {...fields.dtEnd}
              className='margin-bottom-small'
              glyph='glyph glyph-calendar'
            >
              <DatePicker
                {...fields.dtEnd.input}
                disabled={!values.dtStart}
                id={fields.dtEnd.input.name}
                isOutsideRange={(date) =>
                  moment(date).isBefore(values.dtStart) ||
                  !isInclusivelyBeforeDay(date, moment())
                }
                placeholder={translate('field.to')}
                scrollIntoView={false}
                showClearDate
              />
            </Field>
          </Col>
        </Row>
        {!centerFilter && (
          <>
            <Row className='totemreports-custom-margin'>
              <h4>{translate('totem.reports.time.options.title')}</h4>
            </Row>
            <Row className='totemreports-custom-margin'>
              <Field {...fields.timeFilter} radio>
                <Input
                  id='timeAbove'
                  type='radio'
                  value='timeAbove'
                  onChange={this.handleChangeCheckBox}
                  checked={values.timeFilter === 'timeAbove'}
                  label={translate('totem.reports.time.options.above')}
                />
                <Input
                  id='timeUnder'
                  type='radio'
                  value='timeUnder'
                  onChange={this.handleChangeCheckBox}
                  checked={values.timeFilter === 'timeUnder'}
                  label={translate('totem.reports.time.options.under')}
                />
                <Input
                  id='timeAll'
                  type='radio'
                  value='timeAll'
                  onChange={this.handleChangeCheckBox}
                  checked={values.timeFilter === 'timeAll'}
                  label={translate('totem.reports.time.options.all')}
                />
              </Field>
            </Row>
          </>
        )}
        <Row className='margin-top-double'>
          <Col xs={12}>
            <button
              className='button button-primary button-full'
              disabled={
                !values.listRegionsAndBranchs ||
                values.listRegionsAndBranchs.length < 1 ||
                !values.dtStart ||
                !values.dtEnd
              }
            >
              {translate('filter_button_label')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

export default Form({ fields })(ReportsFilter)

export { ReportsFilter }
